import request from '@/utils/request'
import {SettingMer} from '@/utils/settingMer';

/**
 * 获取短信验证码
 */
export function getSMSVerifyCode(data) {
    return request({
        url: SettingMer.apiOrgURL + 'org/mcn/login/forgot/password/send/sms/code',
        method: 'post',
        data
    })
}

/**
 * 使用短信验证码重置密码
 */
export function resetPassword(data) {
    return request({
        url: SettingMer.apiOrgURL + 'org/mcn/login/forgot/password/reset/password',
        method: 'post',
        data
    })
}

/**
 * 忘记密码-校验短信验证码
 */
export function checkSmsCode(data) {
    return request({
        url: SettingMer.apiOrgURL + 'org/mcn/login/forgot/password/check/sms/code',
        method: 'post',
        data
    })
}
